import styled from 'styled-components'

export const SpinnerContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 50px;
`
